import { createAction } from "@reduxjs/toolkit";

export const setModalBuyNow = createAction<any>("modal/setModalBuyNow");
export const setModalBuyTicket = createAction<any>("modal/setModalBuyTicket");
export const setModalBidNow = createAction<any>("modal/setModalBidNow");
export const setModalSuccess = createAction<any>("modal/setModalSuccess");
export const setModalAddFund = createAction<any>("modal/setModalAddFund");
export const setModalConnectWallet = createAction<any>(
  "modal/setModalConnectWallet"
);
export const setModalPaymentTicketSuccess = createAction<any>(
  "modal/setModalPaymentTicketSuccess"
);
export const setModalGameRule = createAction<any>("modal/setModalGameRule");
